<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Pain level: </span>
      <span class="stat-stat">{{ existingEntry.data.painLevel / 10 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"]
}
</script>

<style>

</style>
